export var LIBPREFIX = 'amplitude-ts';
